export function slugify(title: string): string {
  return title
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60);
}

/** `/<workspace>/<slug>-<id>` (just `/<workspace>/<id>` for untitled pages). */
export function pagePath(workspaceSlug: string, pageId: string, title: string): string {
  const slug = slugify(title);
  return `/${workspaceSlug}/${slug ? `${slug}-` : ''}${pageId}`;
}

/** Extracts the 32-hex page id from the last path segment. */
export function pageIdFromSegment(segment: string): string | null {
  const m = /([0-9a-f]{32})$/.exec(segment);
  return m ? m[1]! : null;
}
